export default {
      id: "wizard-info-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "img/icons.svg#wizard-info",
      toString: function () {
        return this.url;
      }
    }